import {
  drawerWidth,
  transition,
  container,
} from "assets/jss/material-dashboard-react.js";

const appStyle = (theme) => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh",
    background:
      "radial-gradient(circle at 18% 100%, rgba(47, 120, 237, 0.24), transparent 34%), #f7fbff",
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch",
    background: "transparent",
    minHeight: "100vh",
  },
  content: {
    marginTop: "0",
    padding: "22px 28px 28px",
    minHeight: "100vh",
    background: "transparent",
    [theme.breakpoints.down("sm")]: {
      padding: "18px 14px 24px",
      marginTop: "0",
    },
  },
  container: {
    ...container,
    maxWidth: "none",
    padding: "0",
  },
  map: {
    marginTop: "70px",
  },
});

export default appStyle;
